const LOCAL_STORAGE_COUPON = 'pharmedistore_coupon'

const COUPON_MANAGER = {
  add: value => {
    const oldCoupons = COUPON_MANAGER.list()
    const newCoupons = [...oldCoupons, value]

    COUPON_MANAGER._set(newCoupons)
  },

  remove: value => {
    const oldCoupons = COUPON_MANAGER.list()
    const newCoupons = oldCoupons.filter(v => v !== value)

    COUPON_MANAGER._set(newCoupons)
  },

  list: () => {
    if (typeof window !== 'undefined')
      return JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_COUPON) || '[]')
  },

  // private method
  _set: value => {
    if (typeof window !== 'undefined')
      window.localStorage.setItem(LOCAL_STORAGE_COUPON, JSON.stringify(value))
  },
  reset: () => {
    if (typeof window !== 'undefined') window.localStorage.removeItem(LOCAL_STORAGE_COUPON)
  },
}

export default COUPON_MANAGER
